<template>
  <div class="ts-app-shell_fh">

    <div style="background-color: #f9f9f9; padding: 15px">     

      <el-row :gutter="2" class="passport-title">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-bottom: 5px;">
          <h3 class="dashboard-title">{{ PassportDetails.taskDescription.title }}</h3>
        </el-col>
      </el-row>

      <el-row :gutter="2" class="passport-description">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-bottom: 5px;">
          <div style="padding: 5px;background-color: #ffffff;font-size: 14px;">
            <span>
              {{ PassportDetails.taskDescription.what_they_do }}
            </span>
          </div>
        </el-col>
      </el-row>   

      <el-row :gutter="2" class="passport-task">        
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" :span="4" style="margin-bottom: 10px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;">On this career, you should:</span>
            </el-row>
            <div class="passport-task" style="margin-bottom: 10px;font-size: 14px;" v-for="(task, index) in PassportDetails.taskDescription.on_the_job.task" :key="index" :name="index">
              <i class="fa fa-check-circle" style="color: #00C8DC"></i> {{ task }}
            </div>
          </div>
        </el-col>
      </el-row> 

      <el-row :gutter="2" class="passport-legend">
        <el-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24" style="margin-bottom: 10px;">
          <div style="font-size: 14px;">
            <span style="padding-right: 30px"><i class="fas fa-square" style="color: green;"></i> You already have this in your profile</span> 
          </div>
        </el-col>
        <el-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24" style="margin-bottom: 10px;">
          <div style="font-size: 14px;">
            <span><i class="fas fa-square" style="color: red;"></i> You don’t have this in your profile</span>
          </div>
        </el-col>
      </el-row>  

      <el-row :gutter="2" class="passport-knowledge-skills-education">

        <!-- Knowledge -->
        <el-col v-if="PassportDetails.knowledge.element" :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 270px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 260px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Knowledge</span>
            </el-row>
            <div class="passport-knowledge" style="margin-bottom: 10px;font-size: 14px;" v-for="(knowledge, index) in PassportDetails.knowledge.element" :key="index" :name="index">
              <span v-if="knowledge.matched"><i class="fa fa-check-circle" style="color: #00C8DC"></i> <span style="color: green;">{{ knowledge.name }}</span> </span>
              <span v-else><i class="fa fa-check-circle" style="color: #00C8DC"></i> <span style="color: red;"> {{ knowledge.name }}</span> </span>
            </div>
          </div>
        </el-col>

        <el-col v-else :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 130px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 120px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Knowledge</span>
            </el-row>
            <span style="font-size: 14px;">{{ PassportDetails.knowledge.errorMessage }}</span> 
          </div>
        </el-col>

        <!-- Skills -->
        <el-col v-if="PassportDetails.skills.element" :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 270px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 260px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Skills</span>
            </el-row>
            <div class="passport-skills" style="margin-bottom: 10px;font-size: 14px;" v-for="(skills, index) in PassportDetails.skills.element" :key="index" :name="index">
              <span v-if="skills.matched"><i class="fa fa-check-circle" style="color: #00C8DC"></i> <span style="color: green;">{{ skills.name }}</span> </span>
              <span v-else><i class="fa fa-check-circle" style="color: #00C8DC"></i> <span style="color: red;"> {{ skills.name }}</span> </span>
            </div>
          </div>
        </el-col>

        <el-col v-else :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 130px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 120px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Skills</span>
            </el-row>
            <span style="font-size: 14px;">{{ PassportDetails.skills.errorMessage }}</span> 
          </div>
        </el-col>

        <!-- Education -->
        <el-col v-if="PassportDetails.education.education_usually_needed" :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 270px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 260px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Education</span>
            </el-row>
            <div class="passport-education" style="margin-bottom: 10px;font-size: 14px;" v-for="(category, index) in PassportDetails.education.education_usually_needed.category" :key="index" :name="index">
              <i class="fa fa-check-circle" style="color: #00C8DC"></i> {{ category }}
            </div>
          </div>
        </el-col>

        <el-col v-else :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 130px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 120px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Education</span>
            </el-row>
            <span style="font-size: 14px;">{{ PassportDetails.education.errorMessage }}</span> 
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="2" class="passport-outlook-technology">                

        <el-col v-if="PassportDetails.technology" :xl="16" :lg="12" :md="24" :sm="24" :xs="24" style="height: 42rem;margin-bottom: 5px;padding: 5px;" class="tech-div">
          <div style="padding: 5px;background-color: #ffffff;height: 41.5rem;" class="tech-div-white">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Technology</span>
            </el-row>
            <div class="passport-technology" style="margin-bottom: 10px;font-size: 14px;" v-for="(category, index) in PassportDetails.technology.category" :key="index" :name="index">
              <span style="font-weight: bold;font-size: 14px;">{{ category.title.name }}</span>
              <div v-for="(item, index) in category.example" :key="index" :name="index"> 
                <span :style="item.matched ? 'color: green': 'color: red'">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </el-col>

        <el-col v-else :xl="12" :lg="12" :md="16" :sm="16" :xs="24" style="height: 130px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 120px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Technology</span>
            </el-row>
            <span>{{ PassportDetails.technology.errorMessage }}</span> 
          </div>
        </el-col>

        <el-col v-if="PassportDetails.jobOutlook.salary" :xl="8" :lg="12" :md="24" :sm="24" :xs="24" style="height: 42rem;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 41.5rem;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Job Outlook</span>
            </el-row>
            <JobOutlookCard :jobOutlook="PassportDetails.jobOutlook"></JobOutlookCard>
          </div>
        </el-col>

        <el-col v-else :xl="8" :lg="8" :md="8" :sm="8" :xs="24" style="height: 130px;margin-bottom: 5px;padding: 5px;">
          <div style="padding: 5px;background-color: #ffffff;height: 120px;">
            <el-row style="margin-bottom: 20px;">
              <span style="font-size: 17px;text-decoration: underline;color: #00C8DC;">Job Outlook</span>
            </el-row>
            <span>{{ PassportDetails.jobOutlook.errorMessage }}</span> 
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="2" class="passport-save">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="height: 40px;margin-bottom: 5px;">
          <div>
            <button v-if="Search" class="ts-btn ts-btn-small" style="float: right;margin-right: 30px;" @click.prevent="savePassport(PassportDetails)" :class="{'loading': BtnLoading}"> <i> <v-icon name="circle-notch" /> </i> Save</button>
            <button v-else class="ts-btn ts-btn-small" style="float: right;margin-right: 30px;" @click.prevent="deletePassport(PassportDetails)">Delete</button>
          </div>
        </el-col>
      </el-row>

    </div>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import JobOutlookCard from "./JobOutlookCard.vue"

export default {
  props: {
    PassportDetails: {
      type: Object,
      default() {
        return null;
      },
    },
    Search: {
      type: Boolean,
      default() {
        return true;
      },
    },
    ChartOptions: {
      type: Object,
      default() {
        return null;
      },
    },
    Series: {
      type: Array,
      default() {
        return [20, 60, 20]
      },
    },
    BtnLoading: {
      type: Boolean,
      default() {
        return false;
      },
    }
  },
  components: {
		apexchart: VueApexCharts,
    JobOutlookCard
  },
  methods: {
    savePassport(PassportDetails) {
      this.$props.BtnLoading = true;
      this.$emit('save-skills-passport', PassportDetails);               
    },
    deletePassport(PassportDetails) {
      this.$emit('delete-skills-passport', PassportDetails);
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 759px) {
  .dashboard-title{
    font-size: 25px !important;
    margin-bottom: 10px !important;
    margin-top: 0 !important;
  }

  .tech-div{
    height: 350px !important;
  }

  .tech-div-white{
    height: 340px !important;
  }

  .passport-outlook{
    width: 100% !important;
  }

  .passport-save{
    margin-bottom: 50px !important;
    margin-top: 2rem;
  }

  .el-message-box__wrapper{
    top: 300px !important;
  }
}

.passport-save{
  margin-top: 2rem;
}
</style>